export default __webpack_public_path__ + "static/media/LUCK.485554ae.png";